/**
 * Action Types
 */
export const ACTIONS = {
    PUT: 'ADMIN_DATABASE_PUT',
};

/**
 * Action Creators
 */
const actionCreators = {
    _put(database)
    {
        return { type: ACTIONS.PUT, payload: { database } };
    },
};

/**
 * Action Dispatchers
 */
export function deleteFromDatabase(id, key)
{
    return (dispatch) =>
    {
        dispatch(actionCreators._delete(id, key));
    };
}


/**
 * Action Dispatchers
 */
export function putDatabase(database)
{
    return (dispatch) =>
    {
        dispatch(actionCreators._put(database));
    };
}
